/**
 * The steps of the shift request wizard, in walk order (GOTU-5396).
 *
 * Deliberately not the ticket's order, which lists `shift_details_viewed` first. Select Dates is
 * the real entry point, and the ticket's order would make `last_step_index` non-monotonic.
 */
export const ShiftRequestFlowStep = {
  SelectDatesViewed: 'select_dates_viewed',
  DatesSelected: 'dates_selected',
  ShiftDetailsViewed: 'shift_details_viewed',
  ShiftDetailsSubmitted: 'shift_details_submitted',
  FillPreferencesSubmitted: 'fill_preferences_submitted',
  ReviewConfirmViewed: 'review_confirm_viewed',
} as const;

export type TShiftRequestFlowStep =
  (typeof ShiftRequestFlowStep)[keyof typeof ShiftRequestFlowStep];

const STEP_ORDER = Object.values(ShiftRequestFlowStep) as TShiftRequestFlowStep[];

/** 1-based position of a step in the wizard. Returns 0 for a step that is not part of the flow. */
export const getShiftRequestStepIndex = (step: TShiftRequestFlowStep): number =>
  STEP_ORDER.indexOf(step) + 1;

/** Whether `next` is further along the wizard than `current`, so back-navigation cannot rewind it. */
export const isLaterShiftRequestStep = (
  next: TShiftRequestFlowStep,
  current: TShiftRequestFlowStep | null,
): boolean =>
  current === null || getShiftRequestStepIndex(next) > getShiftRequestStepIndex(current);
